// extracted by mini-css-extract-plugin
export var divider = "_u4-0";
export var systemMessage = "_u4-1";